module.exports = __webpack_public_path__ + "img/minus.6d176c34.svg";